import { query2obj } from './util';

/**
 * 自动匹配指令绑定的模块数据
 * @param {Object} binding 指令数据
 */
function fixAutoParams(binding) {
  if (!binding.value) return;
  if (typeof binding.value === 'string') {
    // eslint-disable-next-line
    binding.value = query2obj(binding.value);
  }
  // eslint-disable-next-line
  if (binding.modifiers && binding.modifiers.module && binding.value['模块']) {
    // 自动寻找上报数据子节点的模块数据
    // eslint-disable-next-line
    binding.value = binding.value['模块'];
  }
}

// 创建指令
export function createDirective(Vue, middlewares) {
  function directiveHandler(...args) {
    if (Array.isArray(middlewares)) {
      const binding = args[1];
      fixAutoParams(binding);
      middlewares.forEach((middleware) => {
        // eslint-disable-next-line
        middleware.useDirective.apply(middleware, args);
      });
    }
  }

  Vue.directive('report', {
    bind(el, binding, vnode) {
      directiveHandler(el, binding, vnode, { event: 'bind' });
    },
    update(el, binding, vnode) {
      directiveHandler(el, binding, vnode, { event: 'update' });
    },
    unbind(el, binding, vnode) {
      directiveHandler(el, binding, vnode, { event: 'unbind' });
    },
  });
}
